/**
 * Программы сайта — ОДИН список на всё.
 *
 * Отсюда берут и меню «Программы» (MainNavbar), и помощник (ScenarioBot).
 * Раньше у каждого был свой: меню звало программу «События на день», помощник
 * — «Прогноз на день», и человек не понимал, одно это или разное.
 *
 * level — вход в программу. С 14.10.2026 у ВСЕХ программ 'free': вход
 * бесплатный, форму и первую часть результата видит гость, дальше лесенка
 * гость → регистрация → 199 ₽ / ПРО внутри самой программы (решает сервер).
 * Меток «ЛАЙТ / ПРО» у программ нигде нет — ни в меню, ни в помощнике.
 * Программу, целиком закрытую для гостя, здесь нужно пометить 'pro' — тогда
 * помощник допишет к ней «(ПРО)». Сейчас таких нет.
 *
 * openToAll — программа с ПЛАТНЫМ содержимым, но ОТКРЫТОЙ страницей:
 * форму, бесплатный крючок и регистрацию видят все, полный результат
 * отдаёт только сервер и только ПРО.
 *
 * Меню «Программы» уровней больше не показывает и ведёт в каждую программу
 * напрямую (вход без стены, 29.09.2026): форму видит и гость, доступ
 * программа спрашивает на «Рассчитать» (AccessGuard → useAccessGate).
 * level остаётся для помощника (ScenarioBot) и витрины подписки.
 *
 * Женские события — ПРО, а не «доступно всем»: именно так
 * их пускает AccessGuard, и по-другому они не открываются ни у кого, кроме
 * ПРО. Меняете здесь — меняйте и в access_control.py.
 */
/*
 * menuHint — серая подпись под программой в мега-меню «Программы»: что
 * человек узнает, одной строкой (из подзаголовков плиток главной и
 * подводок под заголовками программ).
 */
export const PROGRAMS = [
  { key: 'natal', name: 'Натальная карта', path: '/', level: 'free', emoji: '✨', menuHint: 'Колесо карты и полный разбор', pitch: 'полный разбор твоей карты' },
  { key: 'horar', name: 'Хорар', path: '/horar', level: 'free', emoji: '❓', menuHint: 'Да/нет и срок за минуту', pitch: 'вопросы звёздам без лимита' },
  { key: 'obraz', name: 'Как тебя видят', path: '/obraz', level: 'free', emoji: '\u{1F31F}', menuHint: 'Твоё первое впечатление', pitch: 'твоя сила и образ' },
  // «Твой месяц»: вход бесплатный (гостю 10 дней Удачи, регистрации — весь
  // месяц), полный — 199 ₽ или ПРО внутри программы. Значка ПРО нет.
  { key: 'events_month', name: 'Твой месяц', path: '/events-month', level: 'free', emoji: '\u{1F4C5}', menuHint: 'События и шансы на 30 дней', pitch: 'удачные дни всего месяца' },
  // «Твой год» (/year, 29.10.2026): общее колесо 52 недель по образу колёс
  // «Любовь» и «Деньги» — гостю 2 недели, регистрации 5, всё — ПРО или 199 ₽
  // (урезка на сервере, periods/general_year.py). Страница открыта всем.
  { key: 'year', name: 'Твой год', path: '/year', level: 'free', openToAll: true, emoji: '\u{1F5D3}', menuHint: 'Удачные и трудные недели года', pitch: 'главные события твоего года' },
  // «Партнёр»: так же — гостю шапка и 5 плюсов, регистрации — плюс 5
  // минусов, остальное — 199 ₽ или ПРО внутри программы. Значка ПРО нет.
  { key: 'mum', name: 'Партнёр', path: '/mum', level: 'free', emoji: '\u{1F49E}', menuHint: 'Какой он и где ты его встретишь', pitch: 'какой он и где встретить' },
  // «Как его влюбить» (22.10.2026): по ЕГО дате рождения. Гостю — магнетизм и
  // ключ 1, регистрации — ключи 1–2, 199 ₽ — ключи 1–4, ПРО — всё (ключ 5 только
  // ПРО). Лесенку держит сервер (/api/vlyubit).
  { key: 'vlyubit', name: 'Как его влюбить', path: '/vlyubit', level: 'free', emoji: '\u{1F498}', menuHint: 'Что его цепляет и влюбляет', pitch: 'что его цепляет и влюбляет' },
  { key: 'money', name: 'Где твои деньги', path: '/money', level: 'free', emoji: '\u{1F4B0}', menuHint: 'Как ты притягиваешь деньги', pitch: 'твой источник денег' },
  { key: 'num', name: 'Нумерология', path: '/numerology', level: 'free', emoji: '\u{1F522}', menuHint: 'Пять чисел по имени и дате', pitch: 'числа имени и даты' },
  { key: 'daily3', name: 'События на день', path: '/transits', level: 'free', emoji: '\u{1F52E}', menuHint: 'Настроение дня по часам', pitch: 'твой день по часам' },
  { key: 'women', name: 'Женские события', path: '/women', level: 'free', emoji: '\u{1F338}', menuHint: 'Магнетизм и энергия дня', pitch: 'время для заботы о себе' },
  { key: 'work', name: 'Профессия', path: '/work', level: 'free', emoji: '\u{1F4BC}', menuHint: 'Призвание и сфера успеха', pitch: 'дело, которое тебе подходит' },
  { key: 'para', name: 'Совместимость', path: '/para', level: 'free', openToAll: true, emoji: '\u{1F49E}', menuHint: 'Притяжение и надёжность пары', pitch: 'что вас связывает и разделяет' },
  { key: 'uzel', name: 'Предназначение', path: '/uzel', level: 'free', emoji: '\u{1F33F}', menuHint: 'Куда расти — по лунным узлам', pitch: 'путь и задача души' },
  // openToAll — страница открыта всем, платное содержимое не пускает СЕРВЕР.
  // Ввод, бесплатный крючок и регистрация нужны и гостю, и не-ПРО, поэтому
  // гнать их отсюда на витрину тарифов нельзя: замок стоит внутри страницы.
  { key: 'love', name: 'Любовь и замужество', path: '/love-periods', level: 'free', openToAll: true, emoji: '\u{1F48D}', menuHint: 'Колесо года для любви', pitch: 'когда ждать любви и свадьбы' },
  { key: 'money_periods', name: 'Когда придут деньги', path: '/money-periods', level: 'free', openToAll: true, emoji: '\u{1F4B8}', menuHint: 'Колесо года для денег', pitch: 'денежные месяцы на 3 года' },
  // АстроЧакры: гость видит Муладхару, вошедший — ещё Свадхистхану, всё —
  // ПРО или разовая покупка 199 ₽. Лесенку держит сервер (/api/chakras).
  { key: 'chakry', name: 'АстроЧакры', path: '/chakry-po-natalnoy-karte', level: 'free', openToAll: true, emoji: '\u{1F308}', menuHint: 'Твоя Точка сборки и Зона роста', pitch: 'сила и блоки твоих чакр' },
  // Чакры пары — вкладка АстроЧакр со своим адресом: гость видит два
  // столбика, вошедший — точки сборки, всё — ПРО или 199 ₽ за пару
  // (/api/chakras/pair).
  { key: 'chakry_para', name: 'Чакры пары', path: '/chakry-pary', level: 'free', openToAll: true, emoji: '\u{1F491}', menuHint: 'Энергия ваших отношений', pitch: 'энергия ваших отношений' },
];

/**
 * pitch — что даёт ПРО в программе, 3–5 слов (письма 14-го и 17-го дня,
 * блок «Что открывает ПРО»). Список писем бэкенд держит копией в
 * backend/services/email/pro_programs.py — тест сверяет её с этим файлом:
 * поменяли название, адрес, pitch или порядок здесь — поменяйте и там.
 *
 * PRO_SPOTLIGHT — новые программы ПРО, по одной в день в счётчике подарочных
 * дней (lib/proDays.js): подпись ссылки и ключ программы.
 */
export const PRO_SPOTLIGHT = [
  { key: 'love', label: 'Любовь по твоей карте' },
  { key: 'money_periods', label: 'Деньги по твоей карте' },
  { key: 'chakry', label: 'Чакры по твоей карте' },
];

/**
 * Группы меню «Программы» — по смыслу, а не по тарифам (решение владелицы,
 * 30.09.2026). Порядок групп и программ внутри — как здесь. Названия и
 * адреса берутся из PROGRAMS.
 */
export const PROGRAM_GROUPS = [
  { key: 'self', title: 'Анализ себя', programs: ['natal', 'obraz', 'chakry', 'num'] },
  { key: 'love', title: 'Любовь', programs: ['para', 'chakry_para', 'love', 'mum', 'vlyubit'] },
  { key: 'money', title: 'Деньги и дело', programs: ['money', 'money_periods', 'work', 'uzel'] },
  { key: 'forecast', title: 'Прогнозы', programs: ['horar', 'daily3', 'events_month', 'year', 'women'] },
].map((g) => ({ ...g, programs: g.programs.map((k) => PROGRAMS.find((p) => p.key === k)) }));

/** «Ещё по теме»: count программ из той же группы меню, по порядку меню,
 *  без текущей. Нет такой программы в меню — пусто. */
export function relatedPrograms(current, count = 2) {
  const group = PROGRAM_GROUPS.find((g) => g.programs.some((p) => p && p.key === current));
  if (!group) return [];
  return group.programs.filter((p) => p && p.key !== current).slice(0, count);
}

/** Программа по ключу. Нет такой — undefined, вызывающий решает сам. */
export const programByKey = (key) => PROGRAMS.find((p) => p.key === key);

export default PROGRAMS;
